import { Component, input, output, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LucideAngularModule, ChevronDown } from "lucide-angular";
import { cn } from "../utils/utils";

@Component({
  standalone: true,
  selector: "agent-chat-view-scroll-to-bottom-button",
  imports: [CommonModule, LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <button type="button" [class]="computedClass" [disabled]="disabled()" (click)="handleClick()">
      <lucide-angular [img]="ChevronDown"> </lucide-angular>
    </button>
  `,
})
export class AgentChatViewScrollToBottomButton {
  inputClass = input<string | undefined>();

  disabled = input<boolean>(false);

  onClick = input<(() => void) | undefined>();

  clicked = output<void>();

  protected readonly ChevronDown = ChevronDown;

  get computedClass(): string {
    return cn("achat-scroll-to-bottom", this.inputClass());
  }

  handleClick(): void {
    if (!this.disabled()) {
      if (this.onClick()) {
        this.onClick()!();
      }
      this.clicked.emit();
    }
  }
}
